import { useState } from 'react';

import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import axiosInstance from '../../api/axiosInstance';

export default function AddPrintsDistributionDialog({ open, onClose, onUpdate, entry, accounts }) {
    const [newPrintsDistributionID, setNewPrintsDistributionID] = useState('');
    const [newPrintsDistributionType, setNewPrintsDistributionType] = useState('');
    const [newPrintsDistributionAmount, setNewPrintsDistributionAmount] = useState('');

    const handleSubmit = async () => {
        const newPrintsDistribution =  {account: newPrintsDistributionID, type:newPrintsDistributionType, amount: newPrintsDistributionAmount};
        try {
            const response = await axiosInstance.post(`api/entries/${entry.id}/printsdistributions/create/`, newPrintsDistribution);
            onUpdate(response.data);
        } catch (error) {
            console.error("Erreur lors de l'ajout de la part d'impression.", error);
        } finally {
            onClose();
        }
    };

    return (
        <>
            <Dialog open={open} onClose={onClose}>
                <DialogTitle>Ajouter une part d'impression</DialogTitle>
                <DialogContent>
                    <FormControl fullWidth sx={{ mb: 2, mt: 2 }}>
                        <InputLabel id="demo-simple-select-label">Compte</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={newPrintsDistributionID}
                            label="Compte"
                            onChange={(event) => setNewPrintsDistributionID(event.target.value)}
                        >
                            {accounts.map((account) => (
                                <MenuItem key={account.id} value={account.id}> {account.full_name} </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth sx={{ mb: 2, mt: 2 }}>
                        <InputLabel id="demo-simple-select-label">Type</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={newPrintsDistributionType}
                            label="Type"
                            onChange={(event) => setNewPrintsDistributionType(event.target.value)}
                        >
                            <MenuItem value="B&W">Noir et Blanc</MenuItem>
                            <MenuItem value="C">Couleur</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField
                            label="Quantité"
                            type="number"
                            value={newPrintsDistributionAmount}
                            onChange={(event) => setNewPrintsDistributionAmount(event.target.value)}
                            sx={{ mb: 2, mt: 2 }}
                        />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary">Annuler</Button>
                    <Button onClick={handleSubmit} color="primary">Enregistrer</Button>
                </DialogActions>
            </Dialog>
        </>
    )
};